import React, { useEffect, useState } from "react"
import cx from "classnames"

import Accordion from "@/components/core/Accordion/Accordion"
import ToolTip from "@/components/core/ToolTip/ToolTip"
import Dropdown from "@/components/core/SelectDropdown/SelectDropdown"

import toolTipIcon from "@/public/icons/tooltip.svg"
import styles from "@/components/ProductDetail/v3/OptionsSelector/index.module.scss"

const OptionsSelector = props => {
  const [selected, setSelected] = useState({})
  const [isActive, setIsActive] = useState("")
  const [expanded, setExpanded] = useState(false)
  const {
    i18n = {},
    data = {},
    tooltipdata = {},
    curroptions = [],
    selectoption,
    className = "",
  } = props

  useEffect(() => setSelected(curroptions), [curroptions])

  const formatFacetName = (name = "") => {
    if (props.facetLabels && props.facetLabels[name]) {
      return props.facetLabels[name]
    }
    return name.replace(/\./g, "/").replace(/_/g, " ")
  }

  const handleChange = (value, facet, dropdownName) => {
    if (value !== selected[facet]) {
      const options = {}
      options[facet] = value
      setSelected({ ...selected, ...options })
      selectoption(value, facet, dropdownName)
    }
  }
  const styleClass = cx("options-selector", className)

  const handleTooltipMouseOver = (e, title, tooltipContent) => {
    const {
      target: { className },
    } = e
    if (className) setIsActive(e.target.className)
    const mouseoverTitle = (title + " mouseover").toLowerCase()
    props.selectMoreTooltipHandler(mouseoverTitle, false, tooltipContent)
  }

  const handleOptionExapandState = (isExpanded, title) => {
    setExpanded(isExpanded)
    const accordianState = isExpanded
      ? "accordian expand"
      : "accordian collapse"
    props.configurationAccordianDataLayer(
      `${title?.toLowerCase()}`,
      accordianState
    )
  }

  return (
    <div className={styles.optionsSelectorWrapper}>
      <div className={styleClass}>
        <Accordion
          id="PDP-select-more"
          isOpen={expanded}
          contentOverflow="visible"
          handleOpen={() =>
            handleOptionExapandState(true, `${i18n?.productOptions}`)
          }
          handleClose={() =>
            handleOptionExapandState(false, `${i18n?.productOptions}`)
          }
          title={`${i18n?.productOptions} (${Object.keys(selected).length})`}
        >
          <div className="row">
            {Object.entries(data).map((facet, i) => {
              const values = []
              for (let j = 0; j < facet[1].length; j += 2) {
                values.push(facet[1][j])
              }
              if (curroptions[facet[0]]) {
                return (
                  <div
                    className="options-selector__dropdown col-12 col-sm-6"
                    key={i}
                  >
                    <div className="options-selector__heading">
                      <span>{formatFacetName(facet[0])}</span>
                      <img
                        tabIndex={expanded ? 0 : -1}
                        src={toolTipIcon?.src}
                        alt={i18n.toolTip}
                        className={facet[0]}
                        onMouseLeave={e =>
                          e.target.className ? setIsActive("") : ""
                        }
                        onMouseOver={e =>
                          handleTooltipMouseOver(
                            e,
                            formatFacetName(facet[0]),
                            tooltipdata[facet[0]]
                          )
                        }
                        onFocus={e =>
                          e.target.className
                            ? setIsActive(e.target.className)
                            : ""
                        }
                        onBlur={e =>
                          e.target.className ? setIsActive("") : ""
                        }
                      />
                    </div>
                    <Dropdown
                      id={facet[0]}
                      key={facet[0]}
                      ariaLabel={formatFacetName(facet[0])}
                      data={values}
                      value={selected[facet[0]]?.toString()}
                      onChange={val =>
                        handleChange(val, facet[0], formatFacetName(facet[0]))
                      }
                      tabIndex={expanded ? 0 : -1}
                    />
                    {isActive === facet[0] &&
                    Object.prototype.hasOwnProperty.call(
                      tooltipdata,
                      facet[0]
                    ) ? (
                      <ToolTip message={tooltipdata[facet[0]]} />
                    ) : (
                      ""
                    )}
                  </div>
                )
              }
            })}
          </div>
        </Accordion>
      </div>
    </div>
  )
}

export default OptionsSelector
